<div class="h-100-p" fxLayout="column" fxLayoutAlign="stretch stretch">
  <div
    class="px-16 py-12 mat-accent-bg title-bar"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <div class="h3 title pr-4">{{ title }}</div>
      <div *ngIf="attachmentCount > 0" fxLayout="row" fxLayoutAlign="start center">
        <div class="h3 secondary">({{ attachmentCount }})</div>
      </div>
    </div>
    <div class="actions" fxLayout="row" fxLayoutAlign="start center">
      <div *ngIf="showCasePrepUI && selectedItems?.length > 0" fxLayout="row" fxLayoutAlign="start center">
        <mat-divider class="style-fix" [vertical]="true"></mat-divider>
        <button mat-icon-button class="mat-icon-button"
          matTooltip="Export to Case Preparation File"
          (click)="exportToCasePreparationFileClicked.next()">
          <mat-icon class="mat-accent-bg">
            cloud_upload
          </mat-icon>
        </button>
      </div>
      
      <mat-divider
        *ngIf="showMailMergeTemplateDownloadButton === true"
        class="style-fix"
        [vertical]="true"
      ></mat-divider>
      <button
        mat-icon-button
        class="mat-icon-button"
        matTooltip="Download Mail Merge Data File"
        (click)="btnDownloadMMDataFile()"
        *ngIf="showMailMergeTemplateDownloadButton === true"
      >
        <mat-icon class="fg-icon">cloud_download</mat-icon>
      </button>

      <mat-divider class="style-fix" [vertical]="true"></mat-divider>

      <button
        mat-icon-utton
        class="mat-icon-button"
        [matMenuTriggerFor]="mnuSortOrder"
        attr.aria-label="{{ this.getSortOrderTooltip() }}"
        matTooltip="{{ this.getSortOrderTooltip() }}"
      >
        <mat-icon class="fg-icon">sort</mat-icon>
      </button>
      <mat-menu #mnuSortOrder="matMenu">
        <button
          mat-menu-item
          *ngFor="let order of attachmentService.getSortOrders()"
          (click)="btnApplySortOrder(order)"
        >
          <mat-icon *ngIf="order.selected && order.order !== 1"
            >arrow_drop_down</mat-icon
          >
          <mat-icon *ngIf="order.selected && order.order === 1"
            >arrow_drop_up</mat-icon
          >
          <mat-icon *ngIf="!order.selected"></mat-icon>
          <span>&nbsp;{{ order.title }}</span>
        </button>
      </mat-menu>

      <div *ngIf="showUrls" fxLayout="row" fxLayoutAlign="start center">
        <mat-divider class="style-fix" [vertical]="true"></mat-divider>

        <button
          mat-icon-button
          class="mat-icon-button"
          [matMenuTriggerFor]="mnuFilter"
          aria-label="Filter"
          matTooltip="Filter"
        >
          <mat-icon class="mat-accent-bg">filter_list</mat-icon>
        </button>
        <mat-menu #mnuFilter="matMenu">
          <button
            mat-menu-item
            *ngFor="let filter of this.filters"
            (click)="applyFilter(filter)"
          >
            <mat-icon>{{ filter.icon }}</mat-icon>
            {{ filter.name }}&nbsp;
            <mat-icon *ngIf="filter.selected">done</mat-icon>
          </button>
        </mat-menu>
      </div>

      <div *ngIf="showCasePrepUI && fileCount > 0" fxLayout="row" fxLayoutAlign="start center">
        <mat-divider class="style-fix" [vertical]="true"></mat-divider>
        <button mat-icon-button class="mat-icon-button"
          [attr.aria-label]="selectedItems?.length === fileCount ? 'Deselect All Files' : 'Select All Files'"
          [matTooltip]="selectedItems?.length === fileCount ? 'Deselect All Files' : 'Select All Files'"
          (click)="selectAllClicked.next()">
          <mat-icon class="mat-accent-bg">
            {{ selectedItems?.length === fileCount ? 'check_box_outline' : 'check_box_outline_blank'}}
          </mat-icon>
        </button>
      </div>

      <mat-divider
        *ngIf="allowEdit && this._parent.type === 'subject' && hasSubjectUserEditPrivs"
        class="style-fix"
        [vertical]="true"
      ></mat-divider>

      <button
        *ngIf="allowEdit && this._parent.type === 'subject' && hasSubjectUserEditPrivs"
        mat-icon-button
        class="mat-icon-button"
        (click)="openFileManager()"
        aria-label="Open attachment manager"
        aria-label="Open Attachment Manager"
        matTooltip="Open Attachment Manager"
      >
        <mat-icon class="mat-accent-bg">launch</mat-icon>
      </button>
      <mat-divider
        *ngIf="allowEdit && hasSubjectUserEditPrivs"
        class="style-fix"
        [vertical]="true"
      ></mat-divider>

      <button
        *ngIf="allowEdit && !showUrls && hasSubjectUserEditPrivs"
        mat-icon-button
        class="mat-icon-button"
        aria-label="Add Attachment"
        fxFlex
        aria-label="Add Attachment"
        matTooltip="Add Attachment"
        [disabled]="!allowEdit || !hasSubjectUserEditPrivs"
        #addButton
        (click)="addButton._elementRef.nativeElement.blur(); addFiles()"
      >
        <mat-icon class="fg-icon">add</mat-icon>
      </button>

      <button
        *ngIf="allowEdit && showUrls && hasSubjectUserEditPrivs"
        mat-icon-button
        class="mat-icon-button"
        aria-label="Add Attachment"
        [matMenuTriggerFor]="mnuAdd"
        fxFlex
        aria-label="Add Attachment"
        matTooltip="Add Attachment"
        [disabled]="!allowEdit || !hasSubjectUserEditPrivs"
      >
        <mat-icon class="fg-icon">add</mat-icon>
      </button>
      <mat-menu #mnuAdd="matMenu">
        <button mat-menu-item (click)="addFiles()">Add Files</button>
        <button mat-menu-item (click)="addUrl()">Add URL</button>
      </mat-menu>
    </div>
  </div>
  <file-list 
    [parent]="this._parent" 
    [readOnly]="!allowEdit || !hasSubjectUserEditPrivs" 
    [userCanDeleteAttachments]="userCanDeleteAttachments"
    [selectedItems]="selectedItems"
    [selectAllClicked]="selectAllClicked.asObservable()" 
    [exportToCasePreparationFileClicked]="exportToCasePreparationFileClicked.asObservable()">
  </file-list>
</div>
